<ng-container [style.display]="initialized === true ? 'block' : 'none'">
    <mat-radio-group name="personIsSigningContact" [formControl]="userIsDriverControl">
        <mat-radio-button [value]="true" disableRipple i18n="@@configurator.driver.question-one.yes"
            >Yes</mat-radio-button
        >
        &nbsp;
        <mat-radio-button [value]="false" disableRipple i18n="@@configurator.driver.question-one.no"
            >No</mat-radio-button
        >
    </mat-radio-group>

    <div [style.display]="userIsDriver === true ? 'block' : 'none'">
        <h2 class="checkout-driver__title" i18n="@@configurator.driver.yes-path.title">Your details</h2>
        <p i18n="@@configurator.driver.yes-path.text">
            The contact details we have for you are sufficient. If you accept the offer, we'll check your driver's
            license digitally.
        </p>
    </div>

    <div [style.display]="userIsDriver === false ? 'block' : 'none'">
        <h2 class="checkout-driver__title" i18n="@@configurator.driver.no-path.title">Contact details driver</h2>
        <p i18n="@@configurator.driver.no-path.text">
            If you accept the offer, we'll check the license of the driver digitally.
        </p>

        <div class="form-container form-container--small">
            <mg-email-input [formControl]="driverEmailAddressControl" name="driverEmailAddress"> </mg-email-input>
        </div>
    </div>
</ng-container>
